<template>
  <page :title="i18n.title">
    <div class="about-warp">
      <div class="about-logo">
        <img src="@/assets/imgs/logo.png" alt="">
      </div>
      <div class="about-text">{{ i18n.text }}</div>
      <div>{{ i18n.leam_more }}</div>
      <div class="about-link" @click="onHref('https://www.beesmartconnect.com')">www.beesmartconnect.com</div>
      <div class="about-btn" @click="onHref('https://m.beesmartconnect.com/content/user_agreement.html')">{{ i18n.user_agreement }}</div>
      <div class="about-btn" @click="onHref('https://m.beesmartconnect.com/content/privacy_policy.html')">{{ i18n.privacy_policy }}</div>
      <div class="about-tips">{{ i18n.social_media }}</div>
      <div class="about-external">
        <img @click="onHref('https://www.facebook.com/')" src="@/assets/imgs/icon_facebook_symbol.png" alt="">
        <img @click="onHref('https://www.instagram.com/')" src="@/assets/imgs/icon_instagram_symbol.png" alt="">
        <img @click="onHref('https://www.google.com/')" src="@/assets/imgs/icon_google_symbol.png" alt="">
      </div>
    </div>
  </page>
</template>

<script>
export default {
  computed: {
    i18n() {
      return this.$t("about")
    }
  },
  data() {
    return {
    }
  },
  methods: {
    goRouter(path) {
      this.$router.push(path)
    },
    onHref(path) {
      window.location.href = path
    }
  }
}
</script>

<style lang="less" scoped>
.about-warp {
  padding: 53px;
  font-size: 28px;
  color: #000;
  text-align: center;
  .about-logo {
    width: 120px;
    height: 126px;
    padding: 13px 16px;
    border-radius: 20px;
    background: #FFCA0E;
    margin: 40px auto;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .about-text {
    padding: 0 40px 80px;
  }
  .about-link {
    padding-bottom: 80px;
  }
  .about-btn {
    height: 116px;
    padding-left: 24px;
    text-align: left;
    font-size: 30px;
    background: #F8F6FC;
    border-radius: 18px;
    margin-bottom: 23px;
    display: flex;
    justify-content: start;
    align-items: center;
  }
  .about-tips {
    padding: 120px 0 49px;
    color: rgba(0, 0, 0, 0.45);
  }
  .about-external {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 80px;
    img {
      width: 88px;
      height: 88px;
      display: block;
      margin: 0 26px;
    }
  }
}
</style>
